(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cm-rounded-tile-menu"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function init(root) {
      root.querySelectorAll('.cm-tile-menu').forEach(menu => {
        if (menu.dataset.initialized) return;
        menu.dataset.initialized = 'true';
        const track = menu.querySelector('.cm-tile-menu__track');
        const buttons = menu.querySelectorAll('[data-direction]');
        const update = () => {
          const max = track.scrollWidth - track.clientWidth;
          buttons.forEach(button => {
            button.hidden = max < 2;
            button.disabled = Number(button.dataset.direction) < 0 ? track.scrollLeft <= 1 : track.scrollLeft >= max - 1;
          });
        };
        buttons.forEach(button => button.addEventListener('click', () => {
          track.scrollBy({ left: Number(button.dataset.direction) * track.clientWidth * .8, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        }));
        track.addEventListener('scroll', update, { passive: true });
        const observer = new ResizeObserver(update);
        observer.observe(track);
        menu._cmTileObserver = observer;
        update();
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
    else init(document);
    document.addEventListener('shopify:section:load', event => init(event.target));
    document.addEventListener('shopify:section:unload', event => {
      event.target.querySelectorAll('.cm-tile-menu').forEach(menu => menu._cmTileObserver?.disconnect());
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
